var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floordownload"},[_c('div',{staticClass:"floordownload-btn",on:{"click":_vm.openOfficial}},[_vm._v(" 下载CC加速器，立即体验    "),_c('i',{staticClass:"fa fa-chevron-right",attrs:{"aria-hidden":"true"}}),_c('i',{staticClass:"fa fa-chevron-right",attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }